var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.335 8.33032C19.8068 8.33032 21 7.13716 21 5.66532C21 4.19348 19.8068 3.00032 18.335 3.00032H5.665C4.19316 3.00032 3 4.19348 3 5.66532C3 7.13716 4.19316 8.33032 5.665 8.33032L18.335 8.33032Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.666 12.0052C15.666 13.477 14.4729 14.6702 13.001 14.6702H5.66435C4.19251 14.6702 2.99935 13.477 2.99935 12.0052C2.99935 10.5333 4.19251 9.34017 5.66435 9.34017L13.001 9.34017C14.4729 9.34017 15.666 10.5333 15.666 12.0052Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2227 18.3352C11.2227 19.8071 10.0295 21.0002 8.55766 21.0002H5.66543C4.1936 21.0002 3.00043 19.8071 3.00043 18.3352C3.00043 16.8634 4.19359 15.6702 5.66543 15.6702H8.55766C10.0295 15.6702 11.2227 16.8634 11.2227 18.3352Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolls);
export default __webpack_public_path__ + "static/media/polls.0d1c2aa2e01ed84523319b52b89268ca.svg";
export { ForwardRef as ReactComponent };